import { ElementType, ReactNode } from "react"
import { PolymorphicPropsWithoutRef } from "react-polymorphic-types"
import cn from "classnames"

import { Text, TextProps } from "ui-kit/components-branded/Text/index"
import style from "ui-kit/components-branded/Text/TextWithIcon/style.module.scss"

interface TextWithIconOwnProps extends TextProps {
    icon: ReactNode
    position: "left" | "right"
}

export type TextWithIconProps<T extends ElementType = typeof Text> = PolymorphicPropsWithoutRef<
    TextWithIconOwnProps,
    T
>

export function TextWithIcon<T extends ElementType = typeof Text>({
    icon,
    position,
    className,
    as,
    ...props
}: TextWithIconProps<T>) {
    const TextWrapper: ElementType = as || Text
    return (
        <>
            {position === "left" && icon}
            <TextWrapper {...props} className={cn(style.blmTextWithIcon, className)} />
            {position === "right" && icon}
        </>
    )
}
